import { useNavigate } from "react-router-dom";
import ReportOffSharpIcon from "@mui/icons-material/ReportOffSharp";
import { red } from "@mui/material/colors";
import { Stack } from "@mui/material";

export default function ErrorPage() {
  const navigate = useNavigate();

  return (
    <div id="error-page">
      <h2>
        <Stack direction="row" spacing={3} alignItems="flex-end">
          <ReportOffSharpIcon sx={{ fontSize: 40, color: red[700] }} /> An
          unexpected error has occurred!
        </Stack>
      </h2>
      <p>Press the button below to navigate to the previous page.</p>
      <button className="btn" onClick={() => navigate(-1)}>
        Go Back
      </button>
    </div>
  );
}
